var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middle cadfm-flexitem-stretched"},[_c('action-panel',[_c('action-bar',[_c('b-navbar-nav',[_c('div')])],1),_vm._v(" "),_c('action-content',[_c('Content',{attrs:{"lang":_vm.lang.Content}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-128f267a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Views/Main/Middle/Middle.vue
// module id = null
// module chunks = 